export default {
  'memberPoint.title': 'คะแนนสมาชิก',
  'memberPoint.loyalty.title': 'คะแนนโปรโมชั่น',
  'memberPoint.loyalty.name': 'ชื่อโปรโมชั่น',
  'memberPoint.detail': 'รายละเอียด',
  'memberPoint.store': 'สาขา',
  'memberPoint.point': 'คะแนน',
  'memberPoint.source': 'แหล่งที่มา',
  'memberPoint.update_time': 'เวลาที่ได้รับคะแนน',
  'memberPoint.deduct_time': 'เวลาหักคะแนน',
  'memberPoint.expired_at': 'เวลาหมดอายุ',
  'memberPoint.note': 'หมายเหตุ',
  'memberPoint.details': 'คำอธิบาย',
  'memberPoint.current_point': 'คะแนนสะสมปัจจุบัน',
  'memberPoint.issue_date': 'วันที่ได้รับคะแนน',
  'memberPoint.date': 'ช่วงวันที่',
  'memberPoint.expired': 'กำลังจะหมดอายุ',
  'memberPoint.case': 'เหตุการณ์',
  'memberPoint.receiver': 'ผู้รับ',
  'memberPoint.transfer': 'ผู้โอน',
  'memberPoint.record': 'ประวัติคะแนน',
  'memberPoint.benefit': 'สิทธิประโยชน์คะแนน',
} as Record<string, string>;
